import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom'
import 'styles/app.css'
import 'styles/animations.css'
import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'
import ErrorView from 'components/errorView';
import 'react-app-polyfill/stable'

const bugsnagClient = bugsnag({
    apiKey: '6fa5ddca04d785f4e28546cc3e62f3de',
    /**
     * NOTE: If you'd like to report errors even from the developement phase,
     * add "development" to the list below, or remove the notifyReleaseStages key 
     * completely. 
     */
    notifyReleaseStages: ["production"]
})
bugsnagClient.use(bugsnagReact, React)
var ErrorBoundary = bugsnagClient.getPlugin('react')

function ErrorScreen() {
    return (
        <ErrorView></ErrorView>
    );
}

ReactDOM.render(
    <BrowserRouter>
        <ErrorBoundary FallbackComponent={ErrorScreen}>
            <App />
        </ErrorBoundary>
    </BrowserRouter>,
    document.getElementById('root')
);

export default bugsnagClient

// Remove service worker for now
// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js